import React, { useState, useEffect } from "react";
import "./SurveyExpiredPage.css";


const SurveyExpiredPage = () => {
  const [countdown, setCountdown] = useState(5);
  const message =
    localStorage.getItem("surveyErrorMsg") ||
    "This survey link has expired or been deactivated.";

  useEffect(() => {
    // Countdown redirect logic
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          window.location.href = "/";
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="thankyou-container">
      <div className="thankyou-card">
        <h1 style={{ color: "#a90c2c" }}>⏳ Survey Expired</h1>
        <p>{message}</p>
        <p className="redirect-text">Redirecting to home in {countdown}s...</p>
        <button
          className="thankyou-home-btn"
          onClick={() => (window.location.href = "/")}
        >
          Go to Home Now
        </button>
      </div>
    </div>
  );
};

export default SurveyExpiredPage;
